import { memo, useMemo } from "react";
import { getDay, getMonthName } from "../../utils/GetLongDate";
import { Event } from "@markit/common.types";
import { useTheme } from "../../hooks/useTheme";
import EventDateTimeDisplay from "./EventDateTimeDisplay";
import { getTimezoneTimestamp } from "@markit/common.utils";

type FullEventTimeCardProps = {
  event: Event;
};

const FullEventTimeCard = memo(function FullEventTimeCardFn(
  props: FullEventTimeCardProps
) {
  const { event } = props;
  const { theme } = useTheme();

  const timezoneStart = useMemo(
    () =>
      new Date(getTimezoneTimestamp(event.start, event.timezone)).toISOString(),
    [event.start, event.timezone]
  );

  return (
    <>
      <div
        className="InfoContainerIcon"
        style={{
          ...theme.NewPrimaryBG,
          border: `0.5px solid ${theme.EditableTextFieldBorder.borderColor}`,
        }}
      >
        <p style={{ ...theme.PrimaryText, fontWeight: 600, fontSize: "12px" }}>
          {getMonthName(timezoneStart, true).slice(0, -1)}
        </p>
        <p
          style={{
            color: "#FE296C",
            fontWeight: 600,
            fontSize: "14px",
          }}
        >
          {getDay(timezoneStart)}
        </p>
      </div>
      <EventDateTimeDisplay
        event={event}
        className={"ColumnNormal"}
        containerStyles={{ marginLeft: 14 }}
      />
    </>
  );
});

export default FullEventTimeCard;
